import { ProfileViewModel } from '@models/Auth';
import { OptionsViewModel } from './common.models';

export interface DocumentHistoryViewModel {
  emailHistoryId?: number;
  entityId: number;
  date: Date;
  medium: number;
  status: number;
  type: number;
  documentType: OptionsViewModel;
  recipient: string;
  ownerEmployeeId?: number;
  owner?: ProfileViewModel;
  content: DocumentHistoryContentModel[];
}

export interface DocumentHistoryContentModel {
  text: string;
  documentId?: string;
  documentName?: string;
}

export enum DocumentMedium {
  Email = 0,
  SMS = 1
}

export enum DocumentStatus {
  NotSent = 1,
  Sent,
  Delivered,
  Opened,
  Bounced,
  Rejected
}

// More will be added with email story

export enum DocumentType {
  SwoCreated = 1,
  PurchaseOrder,
  SwoApproval,
  ForgotPassword,
  ContractResale,
  AutoAuthorization,
  Quote,
  DemandLetter,
  ContractConfirmation,
  ContractRenewal,
  PaymentReceipt,
  RenewalNotice
}



// WEBPACK FOOTER //
// ./src/_models/DocumentHistory.ts